import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isPhoneValid } from 'utils/validator';
import useClipboardValue from 'hooks/useClipboardValue';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import KeyboardSmall from 'components/keyboard-small';
import { StyledBlock } from '../StyledComponents';
import ActionsSection from '../ActionsSection';

const PhoneForm = (props) => {
  const { code, initialValue, invalidMessage, buttonLabel, sectionName, onSubmit, children } = props;
  const [phone, setPhone] = useState(initialValue);
  const [isValid, setIsValid] = useState(true);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  const showKeyboard = useCallback(() => setIsKeyboardVisible(true), []);
  const hideKeyboard = useCallback(() => setIsKeyboardVisible(false), []);
  const onKeyboardInput = useCallback(
    (value) => {
      if (value === 'remove') {
        setPhone((prev) => prev.slice(0, -1));
      } else if (value === 'close') {
        setIsValid(isPhoneValid(phone));
        setIsKeyboardVisible(false);
      } else if (!isPhoneValid(phone)) {
        setPhone((prev) => prev + value);
      }
    },
    [phone],
  );
  const onButtonClick = useCallback(() => {
    if (isPhoneValid(phone)) {
      onSubmit({ code, phone });
    } else {
      setIsValid(false);
    }
  }, [code, onSubmit, phone]);

  const value = code + phone;
  const cursorPosition = value.length;

  useClipboardValue((value) => {
    const slicedValue = (value || '').slice(-9);
    isPhoneValid(slicedValue) && setPhone(slicedValue);
  });
  useEffect(() => {
    SpatialNavigationWrapper.focus(isKeyboardVisible ? '@KEYBOARD_NUM' : sectionName);
  }, [isKeyboardVisible, sectionName]);

  return (
    <StyledBlock>
      <ActionsSection sectionName={sectionName} defaultSection>
        <ActionsSection.Input
          value={value}
          isValid={!isKeyboardVisible ? isValid : true}
          invalidMessage={invalidMessage}
          cursor={isKeyboardVisible}
          cursorPosition={cursorPosition}
          onEnter={showKeyboard}
          align="left"
          type="dark"
        />
        <ActionsSection.Button label={buttonLabel} onEnter={onButtonClick} focusOnMouseEnter />
        {children}
      </ActionsSection>
      {isKeyboardVisible && (
        <KeyboardSmall className="keyboard-small__phone" onEnter={onKeyboardInput} onLeave={hideKeyboard} />
      )}
    </StyledBlock>
  );
};

PhoneForm.defaultProps = {
  initilaValue: '',
  sectionName: 'PHONE_NUMBER_INPUT',
};

PhoneForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  invalidMessage: PropTypes.string,
  sectionName: PropTypes.string,
};

export default PhoneForm;
